<template>
  <div :class="$style.root">
    <LayoutSingleTypeHeadingComponent
      :pageData="pageData"
      routeName="program"
    />

    <SharedThumbnailsProgramsComponent
      v-if="childData?.data?.length"
      :thumbnails="childData.data"
    />

    <div
      v-if="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount"
      :class="$style.paginationContainer"
    >
      <button
        :class="$style.paginationButton"
        @click="paginateChildData"
      >
        {{ $t('pagination.loadMore') }}
      </button>
    </div>

    <div
      :class="$style.divider"
      v-if="childData?.data?.length && pastChildData?.data?.length"
    >
      {{ $t('program.archive') }}
    </div>

    <SharedThumbnailsProgramsComponent
      v-if="pastChildData?.data?.length"
      :thumbnails="pastChildData.data"
      :include-groupkey="true"
    />

    <div
      v-if="pastChildData?.meta?.pagination?.page < pastChildData?.meta?.pagination?.pageCount"
      :class="$style.paginationContainer"
    >
      <button
        :class="$style.paginationButton"
        @click="paginatePastChildData"
      >
        {{ $t('pagination.loadMore') }}
      </button>
    </div>
  </div>
</template>

<script setup>
const nuxtApp = useNuxtApp()
const routeName = computed(() => {
  return nuxtApp.$getRouteBaseName()
})

const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  pastChildData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  },
  paginatePastChildData: {
    type: Function,
    required: false,
  },
})
</script>

<style module>
.root {
  display: grid;
  grid-row-gap: var(--unit--vertical--sextuple);
}

.paginationContainer {
  composes: container--default from global;
  display: flex;
  justify-content: center;
}

.paginationButton {
  composes: reset-button from global;
  text-transform: uppercase;
}

.paginationButton:hover {
  color: var(--color--pink);
}

.divider {
  composes: font-size-large from global;
  font-family: 'routed-gothic';

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit--spacer);
  margin: var(--unit--spacer) var(--unit--horizontal--double);
}
</style>
